import { stats } from '../../data/mockData';
import { ButtonLink } from '../ui/Button';

export default function Stats() {
  return (
    <section className="bg-white">
      <div className="section-shell">
        <div className="overflow-hidden rounded-5xl bg-brand-gradient">
          <div className="grid gap-10 p-8 sm:p-12 lg:grid-cols-2 lg:p-16">
            <div className="text-white">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-wider">
                By the numbers
              </span>
              <h2 className="mt-4 text-3xl text-white sm:text-4xl">
                Thirteen years of building IT skills in the Eastern Cape
              </h2>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/70">
                Mokaleng IT has trained learners and supported municipalities,
                law firms, and corporate clients since long before the MICT SETA
                accreditation. The training reflects the support work we do
                every day.
              </p>
              <ButtonLink to="/apply" variant="flare" size="lg" className="mt-8">
                Start your application
              </ButtonLink>
            </div>

            <div className="grid grid-cols-2 gap-4 self-center">
              {stats.map((stat) => (
                <div
                  key={stat.id}
                  className="rounded-3xl bg-white/10 p-6 backdrop-blur-sm"
                >
                  <p className="text-3xl font-extrabold text-white sm:text-4xl">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-sm text-white/65">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
